import React from 'react';
export function ESGDataPlatform() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-946">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-947">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-948">
          <div data-id="element-949">
            <p className="text-sm font-semibold uppercase tracking-widest text-carbon-bright" data-id="element-950">
              ESG Data Management Platform
            </p>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-carbon-deep tracking-tight" data-id="element-951">
              Centralize ESG activity data across every site.
            </h2>
            <p className="mt-4 text-lg text-carbon-deep" data-id="element-952">
              Collect, validate, and attach evidence in one workflow so your
              reporting stays audit-ready and decision-grade.
            </p>
          </div>
          <div className="relative" data-id="element-953">
            <div className="absolute -inset-6 bg-carbon-bright/10 blur-3xl rounded-[48px]" data-id="element-954" />
            <div className="relative rounded-3xl border border-[#9aa6af] bg-white shadow-xl overflow-hidden" data-id="element-955">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/3zho3j7rbfxjzyaqujg3yf/bf50139a-25ca-4767-a015-2905f784a570/assets/ghg-emissions-dashboard.png" alt="Emissions dashboard interface" className="w-full h-auto block" data-id="element-956" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}